/** @jsxImportSource @emotion/react */
import { memo } from 'react';
import { MenuItem, Select } from '@mui/material';
import ArrowExpandIcon from '../../../../../../shared/icons/icons-revamp/arrow_expand';
import { CustomFieldOperatorMetadata, CustomFieldOperatorType } from './typings';

interface Props {
  value: CustomFieldOperatorType;
  operators: CustomFieldOperatorMetadata[];
  onChange: (operator: CustomFieldOperatorMetadata) => void;
}

const OperatorSelect = ({ value, operators, onChange }: Props) => {
  return (
    <Select
      fullWidth
      size="small"
      value={value}
      IconComponent={({ className }) => (
        <ArrowExpandIcon className={className} size={20} color="#7a7a7a" style={{ marginTop: '-3px' }} />
      )}
      onChange={(e) => {
        const next = operators.find((o) => o.type === e.target.value);
        if (next) onChange(next);
      }}
      sx={{
        fontSize: 14,
        background: '#ffffff',
        '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e0e0e9' },
        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(122, 122, 122, 0.5)' },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#3f906d' },
        '& .MuiSelect-icon': { right: 8 },
      }}
    >
      {operators.map((op) => (
        <MenuItem key={op.type} value={op.type} sx={{ fontSize: 14 }}>
          {op.name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default memo(OperatorSelect);
